import React, { useEffect, useState } from "react";
import styles from "./userlist.module.css";
import { Link } from "react-router-dom";
import Helmet from "react-helmet";
import Footer from "../../components/Footer";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, Slide, Snackbar, TablePagination, Typography } from "@mui/material";
import { Archive, ArrowLeft, ArrowRight, Filter, Home, MoreVertical, Plus, Search, Send, Sun, Trash2, X } from "react-feather";
import { Dropdown } from "react-bootstrap";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import Loader from "../../components/Loader";
import { TableLoaderSmall } from "../../components/LoaderC";
import UserAdd from "./components/AddForm";
import { toast } from 'react-smart-toaster';
import { AddLogCallAPI } from "../../components/AddLogs";
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import PeoplePageTitle from "../tenants/components/PeoplePageTitle";
import UserDetails from "./components/UserDetails";
import { formatPhoneNumberIntl } from "react-phone-number-input";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    maxWidth: 400,
    fontSize: 13,
    textAlign: 'left',
  },
}));

const DAYS = [
  { short: "M", full: "Mon" },
  { short: "T", full: "Tue" },
  { short: "W", full: "Wed" },
  { short: "Th", full: "Thu" },
  { short: "F", full: "Fri" },
  { short: "Sa", full: "Sat" },
  { short: "Su", full: "Sun" },
];

const UserList = () => {
  const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [propertyList, setPropertyList] = useState([]);
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState({ searchKey: "", role: "", property: "" });
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [archiveModalOpen, setArchiveModalOpen] = useState(false);
  const [selectecId, setSelectecId] = useState(0);
  const [isArchive, setIsArchive] = useState(false);
  const [perPage, setPerPage] = useState(8);
  const [roleList, setRoleList] = useState([]);
  const [prosDetails, setProsDetails] = React.useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    const fetchRoles = () => {
      return axios.post('https://' + process.env.REACT_APP_AUTH0_DOMAIN + '/oauth/token', { "client_id": process.env.REACT_APP_AUTH0_AUDIENCE_CLIENT_ID, "client_secret": process.env.REACT_APP_AUTH0_AUDIENCE_CLIENT_SECRET, "audience": 'https://' + process.env.REACT_APP_AUTH0_DOMAIN + "/api/v2/", "grant_type": "client_credentials" }, {
        'access-control-allow-origin': '*',
      }).then(response => {
        let managementToken = response?.data?.access_token;

        axios.get('https://' + process.env.REACT_APP_AUTH0_DOMAIN + '/api/v2/roles', {
          headers: {
            Authorization: `Bearer ${managementToken}`,
          }
        }).then(response2 => {
          let roleListTemp = response2?.data?.filter(i => i?.name !== "Super Admin");
          setRoleList(roleListTemp);
        }).catch(() => { });
      }).catch(() => { });
    }

    fetchRoles();
  }, []);

  useEffect(() => {
    const getUserList = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_APPLICANT_API_URL + "v1/get-all-properties", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        setPropertyList([{ value: 'all', label: 'Any' }].concat(response.data.data));
      }).catch(() => {
        setPropertyList([]);
      });
    }

    getUserList();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    const getUserList = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_USER_API_URL + "v1/users", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
      }).catch(() => {
        setContentLoading(false);
      });
    }

    getUserList();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    if (allData.length > 0) {
      let filteredDataTemp = allData;

      if (filterData.searchKey !== "") {
        let inputVal = filterData.searchKey;
        inputVal = inputVal.toLowerCase();
        filteredDataTemp = filteredDataTemp.filter((item) => {
          let phoneStr1 = item?.phone?.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
          let phoneStr2 = item?.phone;
          return (item.name.toLowerCase().includes(inputVal) || item.role.toLowerCase().includes(inputVal) || phoneStr1?.includes(inputVal) || phoneStr2?.includes(inputVal) || item.email.toLowerCase().includes(inputVal));
        });
      }

      if (filterData.property !== "" && filterData.property !== "all") {
        filteredDataTemp = filteredDataTemp.filter((i) => i.property_ids.indexOf(filterData.property) > -1);
      }

      if (filterData.role !== "" && filterData.role !== "all") {
        filteredDataTemp = filteredDataTemp.filter((i) => i.role_id === filterData.role);
      }

      setFilteredData(filteredDataTemp);
    }
  }, [allData, filterData]);

  const userAdd = (data) => {
    setAllData(prev => {
      return [data].concat(prev);
    })
  }

  const userUpdate = (data) => {
    setAllData(prev => {
      let updateList = prev?.map(item => {
        if (item?.id === data?.id)
          return data;
        else
          return item;
      })
      return updateList;
    })
    setSelectedUser(data);
  }

  const confirmDelete = async () => {
    setDeleteModalOpen(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.delete(process.env.REACT_APP_USER_API_URL + 'v1/users-new-phone/' + selectecId, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(response => {
      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);
      setLoading(false);

      let respData = response.data.data;

      setAllData(prev => {
        let updateList = prev?.filter(i => i?.id !== selectecId);
        return updateList;
      })
      setSelectecId(0);

      let logData = {
        'title': 'User is deleted',
        'description': [
          'Name: ' + respData.name,
          'Email: ' + respData.email,
          'Role: ' + respData.role
        ]
      }
      AddLogCallAPI(logData, token);
    }).catch(error => {
      if (typeof error.response !== 'undefined')
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const confirmArchive = async () => {
    setArchiveModalOpen(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    let is_archived = isArchive ? 0 : 1;
    axios.put(process.env.REACT_APP_USER_API_URL + 'v1/users/' + selectecId, { is_archived: is_archived }, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }
    ).then(response => {
      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);
      setLoading(false);

      let respData = response.data.data;

      userUpdate(respData);

      let logData = {
        'title': (respData.is_archived ? 'User is archived' : 'User is unarchived'),
        'description': [
          'Name: ' + respData.name,
          'Email: ' + respData.email,
          'Role: ' + respData.role
        ]
      }
      AddLogCallAPI(logData, token);
    }).catch(error => {
      if (typeof error.response !== 'undefined')
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const sendVerificationLink = async (id) => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios(process.env.REACT_APP_USER_API_URL + 'v1/send-verification-link/' + id, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(response => {
      setLoading(false);
      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);
    }).catch(error => {
      setLoading(false);
      if (typeof error.response !== 'undefined')
        toast.error(error.response.data.message);
    });
  }

  const OpenTaskDetails = (item) => {
    setSelectedUser(item);
    setProsDetails(true);
  };
  const CloseTaskDetails = () => {
    setProsDetails(false);
    setSelectedUser(null);
  };

  // const toggleHrMode = async (id, currentValue) => {
  //   try {
  //     setLoading(true);

  //     const token = await getAccessTokenSilently({
  //       audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  //     });

  //     const updatedValue = currentValue === 1 ? 0 : 1;

  //     const response = await axios.put(
  //       process.env.REACT_APP_USER_API_URL + `v1/users/${id}`,
  //       {
  //         is_hr_mode: updatedValue,
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     const updatedUser = response.data.data;

  //     // Update local state
  //     setAllData((prev) =>
  //       prev.map((user) =>
  //         user.id === id ? updatedUser : user
  //       )
  //     );

  //     setSnackbarOpen(true);
  //     setSnackbarMsg(response.data.message);

  //   } catch (error) {
  //     if (typeof error.response !== "undefined") {
  //       toast.error(error.response.data.message);
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (<>
    {loading && <Loader />}
    <Helmet title="Employees" />

    <div className={`${styles.pageTitleWrap}`}>
      <PeoplePageTitle defaultPage={'Employees'} />
      <Typography display="inline" className={`${styles.pageTitle} ${styles.Big}`}>Employees</Typography>
      <nav aria-label="breadcrumb">
        <ol className={`${styles.breadcrumb}`}>
          <li className={`${styles.breadcrumbItem}`}><span><Home /></span>HR</li>
          <li className={`${styles.breadcrumbItem} ${styles.active}`}>Employees</li>
        </ol>
      </nav>
    </div>

    <div className={`${styles.BodyCon}`}>
      <div className={`${styles.mainCardDiv}`}>
        <div className={`${styles.mainCard}`}>
          {contentLoading && <div className="Loader TableLoader"><TableLoaderSmall /></div>}

          {!contentLoading && <div className="control-pane">
            <div className={`${styles.Row}`}>

              <div className={`${styles.SearchFilterSec}`}>
                <div className={`${styles.SearchCon}`}>
                  <div className={`${styles.SearchConSec}`}>
                    <Search />
                    <input type="text" placeholder="Search" onChange={(e) => setFilterData(prev => { return { ...prev, searchKey: e.target.value } })} />
                  </div>
                </div>
                <div className={`${styles.FilterSec}`}>
                  <div className={!showFilter ? `${styles.FilterFieldSec}` : `${styles.FilterFieldSec} ${styles.Open}`}>
                    <p className={`${styles.FilterTitle}`}>
                      Filters
                      <span onClick={(e) => { setShowFilter(!showFilter) }}>
                        <ArrowRight />
                      </span>
                    </p>
                    <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Property</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Property"
                          onChange={(e) => setFilterData(prev => {
                            return { ...prev, property: e.target.value }
                          })}
                        >
                          {propertyList?.map(item => {
                            return (<MenuItem key={item?.value} value={item?.value}>{item?.label}</MenuItem>);
                          })}
                        </Select>
                      </FormControl>
                    </div>
                    <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Role</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Role"
                          onChange={(e) => setFilterData(prev => {
                            return { ...prev, role: e.target.value }
                          })}
                        >
                          <MenuItem value="all">Any</MenuItem>
                          {roleList?.map(item => {
                            return <MenuItem value={item?.id}>{item?.name}</MenuItem>
                          })}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <Link className={`${styles.FilterBu}`} onClick={(e) => { setShowFilter(!showFilter) }}>
                    <Filter />
                  </Link>
                  {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("user:create") > -1 && <Link className={`${styles.AddNoteBu}`} onClick={(e) => { setAddModalOpen(true) }}>
                    <Plus /><span>Employee</span>
                  </Link>}
                </div>
              </div>

              <div className={`${styles.NotesRow}`}>

                {filteredData.map((item, index) => {
                  return (perPage === -1 || (index >= page * perPage && index < page * perPage + perPage)) ? (<div className={`${styles.ProspectCard}`} onClick={() => OpenTaskDetails(item)}>
                    <div className={`${styles.card}`}>

                      {/* Header */}
                      <div className={`${styles.header}`}>
                        <div className={`${styles.avatarWrap}`}>
                          <div className={`${styles.avatar}`}>
                            {item?.user_image_url !== "" ? (<img src={item?.user_image_url} className={`${styles.defaultImg}`} alt="" />) : (<>{item?.initial}</>)}
                          </div>
                          {item?.is_verified === 1 ? (
                            <div className={`${styles.avatarBadgeVerified}`}>
                              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="5" aria-hidden="true">
                                <polyline points="20 6 9 17 4 12" />
                              </svg>
                            </div>
                          ) : (
                            <div className={`${styles.avatarBadgePending}`}>
                              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#633806" strokeWidth="2.5" aria-hidden="true">
                                <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
                              </svg>
                            </div>
                          )}
                        </div>
                        <div className={`${styles.headerInfo}`}>
                          <div className={`${styles.headerName}`}>{item?.name}</div>
                          <div className={`${styles.headerSub}`}>
                            {item?.property_arr[0]}
                            {item?.property_arr?.length > 1 && <BootstrapTooltip title={item?.property_arr?.join(', ')}>
                              <span className={`${styles.MorePropertyBU}`}>+{item?.property_arr?.length - 1}</span>
                            </BootstrapTooltip>}
                          </div>
                          <span className={`${styles.rolePill}`}>{item?.role}</span>
                        </div>
                        {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("user:update") > -1 || user["https://propertydek.com/permissions"].indexOf("user:delete") > -1) && <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                          <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                            <MoreVertical />
                          </Dropdown.Toggle>

                          <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                            {item.country_code === "US" && item?.is_verified === 0 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { sendVerificationLink(item.id); }}>
                              <Send /> Send Verification Link
                            </Dropdown.Item>}
                            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("user:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setArchiveModalOpen(true); setSelectecId(item.id); setIsArchive(item?.is_archived === 1); }}>
                              <Archive /> {item?.is_archived === 1 ? 'Unarchive' : 'Archive'}
                            </Dropdown.Item>}
                            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("user:delete") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteModalOpen(true); setSelectecId(item.id); }}>
                              <Trash2 /> Delete
                            </Dropdown.Item>}
                          </Dropdown.Menu>
                        </Dropdown>}
                      </div>

                      {/* Info rows */}
                      <div className={`${styles.infoRows}`}>
                        {/* ID Verify */}
                        <div className={`${styles.infoRow}`}>
                          <span className={`${styles.rowIcon}`}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
                              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                            </svg>
                          </span>
                          <span className={`${styles.rowLabel}`}>ID verified</span>
                          <div className={`${styles.rowRight}`}>
                            {item?.is_verified === 1 ? (
                              <span className={`${styles.verifiedPill}`}>
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true"><polyline points="20 6 9 17 4 12" /></svg>
                                Verified
                              </span>
                            ) : (
                              <>
                                <span className={`${styles.pendingPill}`}>
                                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
                                  Pending
                                </span>
                                {item.country_code === "US" && <button className={`${styles.verifyBtn}`} onClick={(e) => { sendVerificationLink(item.id); }}>Verify</button>}
                              </>
                            )}
                          </div>
                        </div>

                        <div className={`${styles.infoRow}`}>
                          <span className={`${styles.rowIcon}`}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
                              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                            </svg>
                          </span>
                          <span className={`${styles.rowLabel}`}>Phone</span>
                          {/*<span className={`${styles.rowValue}`}>{item?.phone?.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")}</span>*/}
                          <span className={`${styles.rowValue}`}>{formatPhoneNumberIntl(item?.isd_code + item?.phone)}</span>
                        </div>

                        <div className={`${styles.infoRow}`}>
                          <span className={`${styles.rowIcon}`}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
                              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" />
                            </svg>
                          </span>
                          <span className={`${styles.rowLabel}`}>Email</span>
                          <span className={`${styles.rowValue} ${styles.emailVal}`}>{item?.email}</span>
                        </div>

                        <div className={`${styles.infoRow} ${styles.infoRowLast}`}>
                          <span className={`${styles.rowIcon}`}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
                              <rect x="5" y="2" width="14" height="20" rx="2" ry="2" /><line x1="12" y1="18" x2="12.01" y2="18" />
                            </svg>
                          </span>
                          <span className={`${styles.rowLabel}`}>Emergency</span>
                          <div className={`${styles.rowRight}`}>
                            {item?.is_receive_emergency_call === 0 && item?.is_receive_tenant_emergency_call === 0 && '-'}
                            {item?.is_receive_emergency_call === 1 && <span className={`${styles.appPill}`}>Management App</span>}
                            {item?.is_receive_tenant_emergency_call === 1 && <span className={`${styles.appPill}`}>Tenant App</span>}
                          </div>
                        </div>
                      </div>

                      {/* HR Mode */}
                      <div className={`${styles.hrSection}`}>
                        <div className={`${styles.hrHeader}`}>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#534AB7" strokeWidth="1.8" aria-hidden="true">
                            <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
                          </svg>
                          <span className={`${styles.hrTitle}`}>HR mode</span>
                          <span
                            className={`${styles.hrLabel} ${item?.is_hr_mode === 1 ? styles.hrLabelOn : ""
                              }`}
                          >
                            {item?.is_hr_mode === 1 ? "enabled" : "disabled"}
                          </span>
                          <button
                            type="button"
                            className={`${styles.toggle} ${item?.is_hr_mode === 1 ? styles.toggleOn : ""
                              }`}
                            // onClick={(e) => {
                            //   e.stopPropagation();
                            //   toggleHrMode(item.id, item?.is_hr_mode);
                            // }}
                            aria-label="Toggle HR mode"
                            aria-pressed={item?.is_hr_mode === 1}
                          >
                            <div className={`${styles.toggleThumb}`} />
                          </button>
                        </div>

                        {item?.is_hr_mode === 1 && (
                          <div className={`${styles.hrBody}`}>
                            <div className={`${styles.dividerLine}`} />

                            <div className={`${styles.hrFieldLabel}`}>Work days</div>
                            <div className={`${styles.dayRow}`}>
                              {DAYS.map((day) => (
                                <span
                                  key={day.full}
                                  className={`${styles.dayChip} ${item?.working_days_arr?.includes(day.full)
                                    ? styles.dayChipActive
                                    : ""
                                    }`}
                                >
                                  {day.short}
                                </span>
                              ))}
                            </div>

                            <div className={`${styles.hrFieldLabel}`}>Shift hours</div>
                            <div className={`${styles.shiftRow}`}>
                              <Sun />
                              <span className={`${styles.TimePill}`}>{item?.checkin_time ? item?.checkin_time : "Not Available"}</span>
                              <span className={`${styles.shiftDash}`}>—</span>
                              <span className={`${styles.TimePill}`}>{item?.checkout_time ? item?.checkout_time : "Not Available"}</span>
                            </div>

                            <div className={`${styles.smsRow}`}>
                              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                              </svg>
                              <span>SMS reminders</span>
                              <span className={`${styles.smsVal}`}>on · {item?.checkin_reminder} before shift</span>
                            </div>

                          </div>
                        )}

                        {item?.is_hr_mode !== 1 && (
                          <div className={`${styles.hrBody}`}>
                            <div className={`${styles.dividerLine}`} />
                            <div className={`${styles.panel} ${styles.panelEmpty}`}>
                              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ color: "#ccc", marginBottom: 10 }} aria-hidden="true">
                                <circle cx="12" cy="12" r="10" />
                                <polyline points="12 6 12 12 16 14" />
                                <line x1="4" y1="4" x2="20" y2="20" />
                              </svg>
                              <div className={`${styles.emptyTitle}`}>HR mode is off</div>
                              <div className={`${styles.emptySub}`}>Enable HR mode to track work schedules,<br />clock-ins, and send SMS shift reminders.</div>
                            </div>
                          </div>
                        )}
                      </div>

                    </div>
                  </div>) : null;
                })}

                {filteredData.length > 0 && (<div className="Pagination TablePaginationNew List">
                  <TablePagination
                    count={filteredData.length}
                    color="primary"
                    page={page}
                    rowsPerPage={perPage}
                    onPageChange={(e, v) => setPage(v)}
                    rowsPerPageOptions={[
                      { label: '4', value: 4 },
                      { label: '8', value: 8 },
                      { label: '16', value: 16 },
                      { label: 'All', value: -1 },
                    ]}
                    onRowsPerPageChange={(e) => {
                      setPage(0);
                      setPerPage(e.target.value);
                    }}
                    labelRowsPerPage={'Users per Page:'}
                  />
                </div>)}

                {!contentLoading && filteredData.length === 0 && (<div className={`${styles.NoDataMain}`}>
                  <div className={`${styles.NoDataIMG}`}>
                    <img src="/static/img/no-prospect.png" alt="No Data" />
                  </div>
                  <p className={`${styles.NoDataText}`}>User list is empty</p>
                  <p className={`${styles.NoDataTextSub}`}>It looks like you haven’t added any users yet.</p>
                </div>)}

              </div>

              <div className={prosDetails === true ? `${styles.ProspectDetailsPanel} ${styles.Open}` : `${styles.ProspectDetailsPanel}`}>
                <div className={`${styles.PanelUnder}`}>
                  <UserDetails
                    selectedUser={selectedUser}
                    CloseTaskDetails={CloseTaskDetails}
                    onUserUpdate={userUpdate}
                    onArchive={(id, isArchived) => {
                      setSelectecId(id);
                      setIsArchive(isArchived);
                      setArchiveModalOpen(true);
                    }}
                    onSendVerification={(id) => sendVerificationLink(id)}
                    propertyList={propertyList}
                    roleList={roleList}
                  />
                </div>
              </div>

            </div>
          </div>}
        </div>
      </div>
    </div >

    <Dialog
      open={deleteModalOpen}
      onClose={(e) => setDeleteModalOpen(false)}
      fullWidth
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">Would you like to delete this user?<button onClick={(e) => setDeleteModalOpen(false)}><X /></button></DialogTitle>
      <DialogContent>
        <div className="ModalFormGroup">
          <label className="PopupBodyText">The user information will be removed immediately.You can't undo this action.</label>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={(e) => confirmDelete()} className="CancelPopupBU">Delete</Button>
        <Button onClick={(e) => setDeleteModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={archiveModalOpen}
      onClose={(e) => setArchiveModalOpen(false)}
      fullWidth
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">Would you like to {isArchive ? 'unarchive' : 'archive'} this user?<button onClick={(e) => setArchiveModalOpen(false)}><X /></button></DialogTitle>
      <DialogContent>
        <div className="ModalFormGroup">
          <label className="PopupBodyText">The user information will be {isArchive ? 'unarchived' : 'archived'} immediately.You can undo this action at anytime.</label>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={(e) => confirmArchive()} className="CancelPopupBU">{isArchive ? 'Unarchive' : 'Archive'}</Button>
        <Button onClick={(e) => setArchiveModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={addModalOpen}
      onClose={(e) => { setAddModalOpen(false) }}
      fullWidth
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp MobileForm"
    >
      <DialogTitle id="alert-dialog-title">
        <button className={`${styles.BackAddBU}`} onClick={(e) => { setAddModalOpen(false) }}><ArrowLeft /></button>
        Add Employee
        <button onClick={(e) => { setAddModalOpen(false) }}><X /></button>
      </DialogTitle>
      <DialogContent>
        <UserAdd setAddModalOpen={setAddModalOpen.bind(this)} setLoading={setLoading.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} userAddLocal={userAdd.bind(this)} editData={null} />
      </DialogContent>
    </Dialog>

    <Dialog
      open={editModalOpen}
      onClose={(e) => { setEditModalOpen(false) }}
      fullWidth
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp MobileForm"
    >
      <DialogTitle id="alert-dialog-title">
        <button className={`${styles.BackAddBU}`} onClick={(e) => { setEditModalOpen(false) }}><ArrowLeft /></button>
        Update User
        <button onClick={(e) => { setEditModalOpen(false) }}><X /></button>
      </DialogTitle>
      <DialogContent>
        <UserAdd setAddModalOpen={setEditModalOpen.bind(this)} setLoading={setLoading.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} userAddLocal={userUpdate.bind(this)} />
      </DialogContent>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      onClose={(e) => setSnackbarOpen(false)}
      TransitionComponent={Slide}
      message={snackbarMsg}
      autoHideDuration={10000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={(e) => setSnackbarOpen(false)}
        >
          <X />
        </IconButton>
      }
    />

    <Footer />
  </>
  )
}

export default UserList;